const moduleRoleMap = new Map([
  ['case', ['admin', 'supervisor', 'trial', 'free_trial']],
  ['user', ['supervisor']],
  ['integation', ['admin', 'supervisor']],
  ['permissions', ['supervisor']],
]);

export { moduleRoleMap };
